var REACT_ELEMENT_TYPE;function _jsx(e, r, E, l) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var o = e && e.defaultProps,n = arguments.length - 3;if (r || 0 === n || (r = { children: void 0 }), 1 === n) r.children = l;else if (n > 1) {for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3];r.children = t;}if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {});return { $$typeof: REACT_ELEMENT_TYPE, type: e, key: void 0 === E ? null : "" + E, ref: null, props: r, _owner: null };} /* eslint-disable react/no-multi-comp */
import React from 'react';
import { createColumnHelper } from '@tanstack/react-table';

import { Translate } from "../../../../../I18N";
import { Button, FileIcon } from "../../../../Components/UI";

const columnHelper = createColumnHelper();

const TitleHeader = () => /*#__PURE__*/_jsx(Translate, {}, void 0, "Name");
const PreviewHeader = () => /*#__PURE__*/_jsx(Translate, {}, void 0, "Preview");
const URLHeader = () => /*#__PURE__*/_jsx(Translate, {}, void 0, "URL");
const ActionHeader = () => /*#__PURE__*/_jsx(Translate, {}, void 0, "Action");

const TitleCell = ({ getValue }) => getValue();
const URLCell = ({ getValue }) => `/assets/${getValue()}`;
const PreviewCell = ({ cell }) => {
  const { mimetype = '', originalname, filename } = cell.row.original;
  return /*#__PURE__*/(
    _jsx("div", { className: "flex justify-center items-center" }, void 0, /*#__PURE__*/
    _jsx(FileIcon, {
      mimetype: mimetype,
      filename: filename,
      altText: originalname,
      className: `flex justify-center items-center ${/^image\//.test(mimetype) ? 'w-14 h-14' : 'w-10 h-14'}` }
    )
    ));

};
const ActionCell = ({ cell }) => {var _cell$column$columnDe, _cell$column$columnDe2;
  const actions = (_cell$column$columnDe = cell.column.columnDef.meta) !== null && _cell$column$columnDe !== void 0 && _cell$column$columnDe.action ? (_cell$column$columnDe2 =
  cell.column.columnDef.meta) === null || _cell$column$columnDe2 === void 0 ? void 0 : _cell$column$columnDe2.action() :
  undefined;

  return /*#__PURE__*/(
    _jsx("div", { className: "flex flex-nowrap gap-2" }, void 0, /*#__PURE__*/
    _jsx(Button, {
      styling: "outline",
      color: "primary",
      className: "leading-3",
      onClick: () => actions.edit(cell.row.original) }, void 0, /*#__PURE__*/

    _jsx(Translate, {}, void 0, "Edit")
    ), /*#__PURE__*/
    _jsx(Button, {
      styling: "outline",
      color: "error",
      className: "leading-3",
      onClick: () => actions.delete(cell.row.original) }, void 0, /*#__PURE__*/

    _jsx(Translate, {}, void 0, "Delete")
    )
    ));

};

const createColumns = (
handleDelete,
editFile) =>
[
columnHelper.display({
  id: 'preview',
  header: PreviewHeader,
  cell: PreviewCell,
  meta: { headerClassName: 'w-0' }
}),
columnHelper.accessor('originalname', {
  id: 'originalname',
  header: TitleHeader,
  cell: TitleCell,
  meta: { headerClassName: 'w-2/4' }
}),
columnHelper.accessor('filename', {
  id: 'filename',
  header: URLHeader,
  cell: URLCell,
  enableSorting: false,
  meta: { headerClassName: 'w-2/4' }
}),
columnHelper.display({
  id: 'action',
  header: ActionHeader,
  cell: ActionCell,
  enableSorting: false,
  meta: {
    action: () => ({ delete: handleDelete, edit: editFile }),
    headerClassName: 'w-0 sr-only'
  }
})];


export { createColumns };